import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const MainLayout = ({ title, children }) => {
  return (
    <div className="app" style={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Topbar title={title} />
        <main style={{ 
          flex: 1, 
          overflowY: 'auto', 
          padding: '24px', 
          background: 'var(--color-background-tertiary)' 
        }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
